import { PAGINATION_ROLE } from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Pagination',
  isConnectGfppEnabled: true,
  panel: {
    height: 212,
    title: 'Connect_Panel_Title_Pagination',
    helpId: 'e8dc9ac9-6244-4402-9339-609cefc52709',
  },
  sections: [
    {
      role: PAGINATION_ROLE,
      bindings: [],
    },
  ],
  compactErrorPanel: true,
  supportsDefaultSelectedDataset: false,
})
